import React from 'react';
import { Shield } from 'lucide-react';
import { getPokemonImageUrl } from '../../utils/imageUtils';

const RaidBossesSection = ({ raidBosses }) => {
  if (!raidBosses || raidBosses.length === 0) return null;

  // Group by tier
  const groupedByTier = raidBosses.reduce((acc, boss) => {
    const tier = boss.tier || 'unknown';
    if (!acc[tier]) acc[tier] = [];
    acc[tier].push(boss);
    return acc;
  }, {});

  const tierLabels = {
    '1-star': '1-Star Raids',
    '3-star': '3-Star Raids',
    '5-star': '5-Star Raids',
    'mega': 'Mega Raids',
    'shadow': 'Shadow Raids'
  };

  return (
    <div className="bg-white rounded-2xl shadow-lg p-6 md:p-8">
      <div className="flex items-center gap-3 mb-6">
        <Shield className="w-6 h-6 text-indigo-500" />
        <h2 className="text-2xl font-bold text-gray-800">Raid Battles</h2>
      </div>
      
      {Object.entries(groupedByTier).map(([tier, bosses]) => (
        <div key={tier} className="mb-6 last:mb-0">
          <h3 className="text-lg font-semibold text-gray-700 mb-3">
            {tierLabels[tier] || tier}
          </h3>
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4">
            {bosses.map((boss, index) => {
              const imageUrl = boss.pokemon_id 
                ? getPokemonImageUrl(boss.pokemon_id)
                : '/images/pokemon/0000.webp';
              
              return (
                <div
                  key={index}
                  className="bg-gray-50 rounded-xl p-4 text-center hover:shadow-md transition-shadow"
                >
                  <img
                    src={imageUrl}
                    alt={boss.pokemon_name || 'Pokemon'}
                    className="w-20 h-20 mx-auto object-contain mb-2"
                    onError={(e) => {
                      e.target.src = '/images/pokemon/0000.webp';
                    }}
                  />
                  <p className="font-medium text-gray-800 text-sm">
                    {boss.pokemon_name || 'Unknown'}
                  </p>
                  {boss.is_shiny_available && (
                    <span className="inline-block mt-1 text-xs text-yellow-600 font-bold">
                      ✨ Shiny
                    </span>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
};

export default RaidBossesSection;
